


















































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import CouponDefine from '@/model/coupon/couponDefine'
import Coupon from '@/model/coupon/coupon'
import { Account } from 'ykd-base/account'
import qs from 'query-string'
import moment from 'moment'
import { queryAccountByIds } from '@/api/account/account'
import { getPartnerAccount } from '@/api/coupon/partner'
import { initWxShare } from '@/apps/sandwich/utils/share'
import { CollegeProduct } from '@/model/product/collegeProduct'
import { getCollegeProduct } from '@/api/product/product'

import { getCouponDefine } from '@/api/coupon/couponDefine'
import {
  getCoupon,
  receive,
  requestWxConfing,
  getLatestCoupon
} from '@/api/coupon/coupon'
@Component
export default class couponDetails extends Vue {
  private coupon: Coupon = { product: {} }
  private isShowShare: boolean = false
  private validity: string = ''
  private btnDefalut: string = '领取并使用'
  private partnerAccountId: string = ''
  private couponDefineId: string = ''
  private avatarUrl: string = ''
  private userName: string = ''
  private userAvatarUrl: string = ''
  private couponDefine: CouponDefine = { product: {} }
  private collegeProduct: CollegeProduct = {}
  async mounted() {
    await this.initDate()
  }
  @Watch('$route')
  async initRoute() {
    await this.initDate()
  }

  async initDate() {
    //查询优惠卷信息
    await initWxShare(
      '和焦哥一起探索编程的乐趣',
      '与其感慨路难行，不如马上出发！'
    )
    this.partnerAccountId = this.$route.query.partnerAccountId as string
    this.couponDefineId = this.$route.query.couponDefineId as string
    this.coupon = await getLatestCoupon(
      this.partnerAccountId,
      this.couponDefineId
    )
    this.couponDefine = await getCouponDefine(this.couponDefineId)

    this.validity = moment()
      .add(7, 'days')
      .format('YYYY-MM-DD HH:mm:ss')

    if (this.coupon && this.coupon.endTime) {
      let month =
        this.momentDataFormat(this.coupon.endTime).getMonth() < 10
          ? '0' + this.momentDataFormat(this.coupon.endTime).getMonth()
          : this.momentDataFormat(this.coupon.endTime).getMonth()
      let day =
        this.momentDataFormat(this.coupon.endTime).getDate() < 10
          ? '0' + this.momentDataFormat(this.coupon.endTime).getDate()
          : this.momentDataFormat(this.coupon.endTime).getDate()
      let hours =
        this.momentDataFormat(this.coupon.endTime).getHours() < 10
          ? '0' + this.momentDataFormat(this.coupon.endTime).getHours()
          : this.momentDataFormat(this.coupon.endTime).getHours()
      let minutes =
        this.momentDataFormat(this.coupon.endTime).getMinutes() < 10
          ? '0' + this.momentDataFormat(this.coupon.endTime).getMinutes()
          : this.momentDataFormat(this.coupon.endTime).getMinutes()
      let seconds =
        this.momentDataFormat(this.coupon.endTime).getSeconds() < 10
          ? '0' + this.momentDataFormat(this.coupon.endTime).getSeconds()
          : this.momentDataFormat(this.coupon.endTime).getSeconds()
      this.validity =
        this.momentDataFormat(this.coupon.endTime).getFullYear() +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds
      this.btnDefalut = '立即使用'
    }
    //判断是否是合伙人

    const account = await getPartnerAccount()
    this.avatarUrl = account.user.avatarUrl!
    this.userName = account.user!.name!
    if (account) {
      if (account.companyId! === '5e2028f4e65547606efc927d') {
        //是合伙人
        this.validity = moment()
          .add(7, 'days')
          .format('YYYY-MM-DD HH:mm:ss')
        this.btnDefalut = '立即使用'
      }
    }
  }
  @Watch('couponDefineId')
  async initPrice() {
    await this.initDate()
  }
  dateFormat(time: any) {
    var date = new Date()

    date = new Date(date.getTime() + 604800000)
    var year = date.getFullYear()

    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month =
      date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    var minutes =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    var seconds =
      date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    // 拼接
    return (
      year +
      '/' +
      month +
      '/' +
      day +
      ' ' +
      hours +
      ':' +
      minutes +
      ':' +
      seconds
    )
  }
  private momentDataFormat(data: string) {
    return moment(data)
      .add(1, 'month')
      .toDate()
  }
  private momentData(data: string) {
    return moment(data).toDate()
  }
  //领取优惠卷
  async receive() {
    //怕断优惠卷是否过期
    let endTime = this.momentData(this.validity).getTime()

    if (moment().valueOf() > endTime) {
      console.log('444')
      this.$ykdmessage({
        message: '优惠卷已过期',
        duration: 1500,
        cancel: () => {},
        type: 'success'
      })
      return
    }
    const result = await receive(this.couponDefineId, this.partnerAccountId)
    console.log(result)

    if (result) {
      //弹窗提示领取成功
      this.$ykdmessage({
        message: '领取成功！正在跳转商品页',
        duration: 1500,
        cancel: () => {},
        type: 'success'
      })
      const courseId = this.couponDefine!.product!.id!
      //判断是否是学院商品
      if (this.couponDefine!.product!.productType === 'EMPLOYMENT') {
        this.$router.push({
          path: '/home_m/fasttrack'
        })
      } else if (
        this.couponDefine!.product!.productType === 'COLLEGE' ||
        this.couponDefine!.product!.productType === 'COMBINATIONPACKAGE'
      ) {
        this.collegeProduct = this.couponDefine!.product!
        this.collegeProduct = await getCollegeProduct(courseId)
        //跳转到商品页
        //判断是python还是engineer
        if (courseId.indexOf('py') != -1) {
          this.$router.push({
            path: '/home_m/college',
            query: {
              courseid: courseId,
              college: 'python'
            }
          })
        } else {
          this.$router.push({
            path: '/home_m/college',
            query: {
              courseid: courseId,
              college: 'engineer'
            }
          })
        }
      } else if (this.couponDefine!.product!.productType === 'COURSE') {
        //跳转到商品页
        this.$router.push({
          path: '/home_m/coursedetail',
          query: {
            courseid: courseId
          }
        })
      }
    }
  }
  shutDown() {
    this.isShowShare = false
  }
  async share() {
    this.isShowShare = true
  }
}
